import React, { useContext } from "react";
// @ts-ignore
import Pluralize from "react-pluralize";
import { withCartIdParam } from "../../utils/BrowserHelper";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";
import { Cart, Event } from "./types";
import { LightBoxViewCartIcon } from "./vectors/LightBoxCartIcons";
import { EventGalleryContext } from "./index";

const EmbedHeader = ({
  cart,
  isEmbed,
  primaryColor,
  event
}: {
  cart: Cart;
  isEmbed: boolean;
  primaryColor: string;
  event?: Event;
}) => {
  const context = useContext(EventGalleryContext);
  
  const photosCount = () => {
    if (cart) {
      const isPrintProductEvent =
        event?.hasPrintProducts && context?.lightboxPrintProductsEnabled;

      if (isPrintProductEvent) {
        if (cart.sales_count !== undefined && cart.sales_count !== null) {
          return cart.sales_count;
        }
      }

      if (cart.photos) {
        return cart.photos.length;
      }
    }
    return 0;
  };

  return (
    <div className="dv-embed-header">
      <a href="https://geosnapshot.com" target="_blank">
        <div className="embed-branding"></div>
      </a>

      <div className="embed-checkout">
        {photosCount() > 0 ? (
          <span className="cart-photos">
            <Pluralize singular="photo" count={photosCount()} />
          </span>
        ) : null}
        <a
          href={withCartIdParam(
            "/checkout?source=embed-nav-bar",
            cart ? cart.id : null,
            isEmbed
          )}
          target={isEmbed ? "_blank" : ""}
          className="btn btn-primary checkout"
        >
          <LightBoxViewCartIcon
            color={ContrastForegroundUtility.fgColor(primaryColor)}
          />{" "}
          View Cart
          {photosCount() > 0 ? (
            <span className="photos">&nbsp;({photosCount()})</span>
          ) : null}
        </a>
      </div>
    </div>
  );
};

export default EmbedHeader;
